import { render, staticRenderFns } from "./EventDescriptionEditor.vue?vue&type=template&id=84d74b42&scoped=true&"
import script from "./EventDescriptionEditor.vue?vue&type=script&lang=ts&"
export * from "./EventDescriptionEditor.vue?vue&type=script&lang=ts&"
import style0 from "./EventDescriptionEditor.vue?vue&type=style&index=0&id=84d74b42&scoped=true&lang=scss&"
import style1 from "./EventDescriptionEditor.vue?vue&type=style&index=1&lang=css&"
import style2 from "@kangc/v-md-editor/lib/style/base-editor.css?vue&type=style&index=2&lang=css&"
import style3 from "@kangc/v-md-editor/lib/theme/style/github.css?vue&type=style&index=3&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84d74b42",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VDivider,VSpacer})
